import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import queryString from 'query-string';
import * as homeActions from '../actions/homeActions';
import {userActions} from '../actions/userActions';
import {removeState} from '../store/localStorage';

export class LandingPage extends React.Component {
    constructor(props) {
      super(props);
    }
  
    render(){
  
      const parsed = queryString.parse(location.search);
      let locationId=parsed.locationId;
      removeState();
      this.props.userActions.reset();
      this.props.userActions.logout();
      this.props.homeActions.setSelectedLocation(locationId).then(()=>{
        this.props.history.push("/");
        window.scrollTo(0, 0);
      });
   
  
     
  
  
      return(
          <div>
              
          </div>
      )
    }
  
  
   
  }
  LandingPage.propTypes = {
    homeActions: PropTypes.object.isRequired,
    history: PropTypes.object,
    userActions:PropTypes.object
  };
  
  
  
  function mapDispatchToProps(dispatch) {
    return {
      homeActions: bindActionCreators(homeActions, dispatch),
      userActions: bindActionCreators(userActions, dispatch)
    };
  }
  
  export default connect(
    null,
    mapDispatchToProps
  )(LandingPage);


// WEBPACK FOOTER //
// ./src/containers/LandingPage.jsx